export class PendingDiscountDetails {
    companyName: string;
    companyId: string;
    submitterId: string;
    submitterName: string;
    value: string;
    submissionDate: Date;
    startDate: string;
    endDate: string;
    redemptionLimit: number;
    discountId: number;
    approverNotes: string;
    isClosed: boolean;
    status: string;
}